import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

export const DeleteAssignmentStrategyButton = ({
  deleteAssignmentStrategy,
  isLoading,
}: {
  deleteAssignmentStrategy: () => Promise<void>;
  isLoading: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  return (
    <>
      <Button
        color={colors.info}
        variant="link"
        ariaLabel="delete strategy"
        label="Delete strategy"
        onClick={() => onOpen()}
      >
        Delete
      </Button>

      <AlertDialog
        leastDestructiveRef={cancelRef.current}
        isOpen={isOpen}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete strategy?
            </AlertDialogHeader>

            <AlertDialogBody>
              Your strategy will no longer be shown as an option.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef.current} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="aurora"
                isLoading={isLoading}
                onClick={async () => {
                  await deleteAssignmentStrategy();
                  onClose();
                }}
                ml={3}
              >
                Delete strategy
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
